import { provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideNgxStripe } from 'ngx-stripe';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ActivatedRoute, provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { MockRouterInjectable } from '../mockRouterInjectable';
import { environment } from '../environments/environment';

export const appConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideAnimations(),
    provideHttpClient(),
    provideNgxStripe(),
    { provide: ActivatedRoute, useClass: MockRouterInjectable },
  ],
};

export const standaloneAppConfig = {
  providers: [provideRouter(routes), ...appConfig.providers],
};
